import { Typography } from 'design-system/src/components/Typography/Typography';
import Hairline from 'design-system/src/components/Hairline/Hairline';
import Button from 'design-system/src/components/Button/Button';
import type { EhrIntegrationFormProps } from './EhrIntegrationForm';
import { FormContainer, BodyContainer } from './styles';
import { PROVIDER_SUPPORT_CONTACT_INFO } from '../../../constants';

/**
 * EHR integration instructions component for unsupported EHR types.
 * Shows a message that the EHR is not currently supported and provides contact info.
 */
export const NotSupportedInstructions = ({ className, ehrType }: EhrIntegrationFormProps) => {
  const emailLink = (
    <Button
      variant="link"
      href={`mailto:${PROVIDER_SUPPORT_CONTACT_INFO.email}`}
      className="!text-purple-700 hover:!text-purple-900"
      textStyledAs="bodyDMSans"
    >
      {PROVIDER_SUPPORT_CONTACT_INFO.email}
    </Button>
  );

  const instructions = ehrType ? (
    <>
      Integration with {ehrType} is not currently supported. Please call us at {PROVIDER_SUPPORT_CONTACT_INFO.phone} or
      email {emailLink} for assistance.
    </>
  ) : (
    <>
      This EHR system is not currently supported for direct integration. Please call us at{' '}
      {PROVIDER_SUPPORT_CONTACT_INFO.phone} or email {emailLink} for assistance.
    </>
  );

  return (
    <FormContainer className={className}>
      <Typography styledAs="h6">EHR Integration</Typography>
      <Hairline />
      <BodyContainer>
        <Typography>{instructions}</Typography>
      </BodyContainer>
    </FormContainer>
  );
};
